import { FormControl, Validators } from '@angular/forms';
import { DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, startWith } from 'rxjs';
import { isEmptyString, isNil, Nillable } from '@web/utils';

export const companyNameAndNipCrossValidation = (options: {
  companyNameControl: FormControl<Nillable<string>>;
  companyNipControl: FormControl<Nillable<string>>;
  destroyRef: DestroyRef;
}): void => {
  const { companyNipControl, companyNameControl, destroyRef } = options;

  companyNipControl.valueChanges
    .pipe(
      startWith(companyNipControl.value),
      distinctUntilChanged(),
      takeUntilDestroyed(destroyRef),
    )
    .subscribe((nip) => {
      if (isNil(nip) || isEmptyString(nip)) {
        companyNameControl.removeValidators([Validators.required]);
      } else {
        companyNameControl.addValidators([Validators.required]);
      }

      companyNameControl.updateValueAndValidity({ emitEvent: false });
    });

  companyNameControl.valueChanges
    .pipe(
      startWith(companyNameControl.value),
      distinctUntilChanged(),
      takeUntilDestroyed(destroyRef),
    )
    .subscribe((name) => {
      if (isNil(name) || isEmptyString(name)) {
        companyNipControl.removeValidators([Validators.required]);
      } else {
        companyNipControl.addValidators([Validators.required]);
      }

      companyNipControl.updateValueAndValidity({ emitEvent: false });
    });
};
